import { MenuItem } from "@sphera-cloud/component-ui-reactjs";

interface Link {
  id?: string;
  label: string;
  url: string;
  newTab?: boolean;
  onClick?: () => void;
}

const config = {
  baseConfig: {
    appSwitcherHeader: '',
    activeSolutionFamily: 'Chemical Management',
    rootComponent: '#sch',
    baseUrl: '/',
    mobileMenu: false,
    footer: {
      url: 'https://sphera.com',
      label: 'Explore Additional SpheraCloud Solutions',
    },
  },
  user: {
    name: '',
    email: '',
    company: '',
    menuItems: [] as typeof MenuItem[],
  },
  help: {
    links: [
      {
        label: 'Get Help',
        id: 'schHelp',
        newTab: true,
      },
      {
        label: 'Helpdesk (new Tab)',
        id: 'schHelpDesk',
        newTab: true,
      },
      {
        label: 'About',
        id: 'dimaAbout',
      },
    ] as Link[],
  },
  appSwitcher: [
    {
      product_line: 'SpheraCloud Apps',
      prependBeforeSubscribedItems: false,
      solutionFamilies: [
        {
          group: '',
          iconColor: '',
          url: '',
          shortcut: '',
        },
      ],
    },
  ],
};

export default config;